import update from "immutability-helper";
import client from "lib/apolloClient/client";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { resetPasswordMutation } from "modules/CommonMutations";

export const NAME = "adminCommon";
export const CHANGE_SEARCH_TERM = "CHANGE_SEARCH_TERM" + " " + NAME;
export const SET_ACCOUNT_ACL_ROLES = "SET_ACCOUNT_ACL_ROLES" + " " + NAME;
export const SET_PROGRAM_ACL_ROLES = "SET_PROGRAM_ACL_ROLES" + " " + NAME;
export const SET_SHOW_RESULTS_WITH_NO_PROGRAMME_ROLES =
  "SET_SHOW_RESULTS_WITH_NO_PROGRAMME_ROLES" + " " + NAME;
export const RESET_ITEM = "RESET_ITEM" + " " + NAME;
export const UPDATE_SELECTED_LIST = "UPDATE_SELECTED_LIST" + " " + NAME;
export const UPDATE_LOADING = "UPDATE_LOADING" + " " + NAME;
export const INIT_SELECTED_LIST = "INIT_SELECTED_LIST" + " " + NAME;
export const SET_EXCLUDED_COURSEIDS = "SET_EXCLUDED_COURSEIDS" + " " + NAME;
export const SET_EXCLUDED_IDS = "SET_EXCLUDED_IDS" + " " + NAME;
export const UPDATE_FAMILY_EMAILS = "UPDATE_FAMILY_EMAILS" + " " + NAME;
export const INIT_FAMILY_EMAILS = "INIT_FAMILY_EMAILS" + " " + NAME;
export const TOGGLE_ACTION_LOADING = "TOGGLE_ACTION_LOADING" + " " + NAME;

// PURE ACTIONS
export const changeSearchTerm = value => {
  return { type: CHANGE_SEARCH_TERM, payload: value };
};

export const changeAccountAclRoles = value => {
  return { type: SET_ACCOUNT_ACL_ROLES, payload: value };
};

export const changeProgramAclRoles = value => {
  return { type: SET_PROGRAM_ACL_ROLES, payload: value };
};

export const setShowResultsWithNoProgrammeRoles = value => {
  return { type: SET_SHOW_RESULTS_WITH_NO_PROGRAMME_ROLES, payload: value };
};

export const setExcludedIds = value => {
  return { type: SET_EXCLUDED_IDS, payload: value };
};

export const resetItem = value => {
  return { type: RESET_ITEM, payload: value };
};

export const toggleActionLoading = data => {
  return {
    type: TOGGLE_ACTION_LOADING,
    data,
  };
};

export const updateSelectedList = data => {
  return {
    type: UPDATE_SELECTED_LIST,
    payload: data,
  };
};

export const updateLoading = data => {
  return {
    type: UPDATE_LOADING,
    payload: data,
  };
};

export const initSelectedList = () => {
  return {
    type: INIT_SELECTED_LIST,
  };
};

//  Thunks

export const resetPasswordDetails = params => {
  params.is_password_updated = !params.is_password_updated;

  return async dispatch => {
    dispatch(toggleActionLoading(true));
    try {
      await client.mutate({
        mutation: resetPasswordMutation,
        variables: params,
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:saved_successfully",
        })
      );
      return true;
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      return false;
    } finally {
      dispatch(toggleActionLoading(false));
    }
  };
};

// ------------------------------------
// Reducer Handlers
// ------------------------------------
const REDUCER_HANDLERS = {
  [CHANGE_SEARCH_TERM]: (state, action) => {
    const type = action.payload.type;
    return update(state, {
      searchTerm: { [type]: { $set: action.payload.searchText } },
    });
  },
  [SET_ACCOUNT_ACL_ROLES]: (state, action) => {
    return update(state, { accountAclRoles: { $set: action.payload } });
  },
  [SET_PROGRAM_ACL_ROLES]: (state, action) => {
    return update(state, { programAclRoles: { $set: action.payload } });
  },
  [SET_SHOW_RESULTS_WITH_NO_PROGRAMME_ROLES]: (state, action) => {
    return update(state, {
      showOnlyResultsWithNoProgramACLRoles: { $set: action.payload },
    });
  },
  [SET_EXCLUDED_COURSEIDS]: (state, action) => {
    return update(state, { excludedCourseIds: { $push: [action.payload] } });
  },
  [SET_EXCLUDED_IDS]: (state, action) => {
    const type = action.payload.type;
    return update(state, {
      excludedIds: { [type]: { $set: action.payload.value } },
    });
  },
  [UPDATE_SELECTED_LIST]: (state, action) => {
    const params = action.payload;
    const value = params.value;
    const opt = params.opt;
    const index = params.index;
    const type = params.type;
    if (value) {
      state = update(state, { selectedList: { [type]: { $push: [opt] } } });
    } else {
      state = update(state, {
        selectedList: { [type]: { $splice: [[index, 1]] } },
      });
    }
    return state;
  },
  [RESET_ITEM]: (state, action) => {
    const type = action.payload.type;
    return update(state, {
      searchTerm: { [type]: { $set: "" } },
      selectedList: { [type]: { $set: [] } },
      excludedCourseIds: { $set: [] },
      excludedIds: { $set: initialState.excludedIds },
    });
  },
  [UPDATE_LOADING]: (state, action) => {
    const params = action.payload;
    Object.keys(params).map(key => {
      state = update(state, { isLoading: { [key]: { $set: params[key] } } });
    });
    return state;
  },
  [INIT_SELECTED_LIST]: state => {
    return update(state, { selectedList: { $set: initialState.selectedList } });
  },
  [UPDATE_FAMILY_EMAILS]: (state, action) => {
    state = update(state, {
      familyEmails: { $set: action.payload.familyEmails },
    });
    return state;
  },
  [INIT_FAMILY_EMAILS]: state => {
    return update(state, { familyEmails: { $set: initialState.familyEmails } });
  },
  [TOGGLE_ACTION_LOADING]: (state, action) => {
    return update(state, {
      isActionLoading: { $set: action.data },
    });
  },
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  searchTerm: {
    courses: "",
    teachers: "",
    students: "",
  },
  accountAclRoles: [],
  programAclRoles: [],
  showOnlyResultsWithNoProgramACLRoles: null,
  selectedList: {
    courses: [],
    teachers: [],
    students: [],
  },
  isLoading: {
    createCourse: false,
  },
  excludedCourseIds: [],
  excludedIds: {
    courses: [],
    teachers: [],
    students: [],
  },
  familyEmails: [],
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
